// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2YFDu","left":"StickyBox_left__tJhzU","right":"StickyBox_right__efCeC"};